import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

type ShapeTextEditLifecycleRef = Pick<
  ShapeManagerRef,
  'getEditingShapeTextId' | 'exitShapeTextEdit'
>

/**
 * Finalizes active embedded-shape text editing before global actions
 * like tool switches and undo/redo history steps.
 */
export function finalizeActiveShapeTextEdit(
  shapeManager: ShapeTextEditLifecycleRef | null | undefined
): boolean {
  if (!shapeManager) return false

  const editingShapeTextId = shapeManager.getEditingShapeTextId()

  if (!editingShapeTextId) return false

  shapeManager.exitShapeTextEdit()

  return true
}
